import { serializeParams } from "@/utils/apiUtils";
import { AxiosPromise } from "axios";
import { ApiRequestAdapter } from "../../common/api/ApiRequestAdapter";
import { apiService } from "../../common/api/apiService";
import { HttpMethod } from "../../common/api/http";
import { GlobalSearchRequest, GlobalSearchResult } from "./types";

const SEARCH_GLOBALLY = ApiRequestAdapter.create("/global-search", HttpMethod.GET);

export const globalSearchApi = {
  searchGlobally: (request: GlobalSearchRequest): AxiosPromise<GlobalSearchResult> => {
    return apiService.get(SEARCH_GLOBALLY.url, { params: request, paramsSerializer: { serialize: serializeParams } });
  },
};
